export default "__VITE_ASSET__BSrU7IZO__"